<div
  class="u-padding-16 u-card bg-color-white mat-elevation-z1"
  [ngSwitch]="segmentationKey"
>
  <ng-container *ngSwitchCase="'offerings'">
    <div fxLayout="row" fxLayoutAlign="space-between start">
      <div fxFlex="60%">
        <p
          class="u-marginBottom-16 text-subtitle-2"
          i18n="@@hubConfigSegmentation.goals.title"
        >
          Goals
        </p>
        <p
          class="color-grey-300 u-marginBottom-16"
          i18n="@@hubConfigSegmentation.goals.description"
        >
          Goals are categories of experiences offered to members of this
          community. Members select goals to choose the experiences they want to
          get.
        </p>
        <p
          class="color-grey-300 u-marginBottom-16"
          i18n="@@hubConfigSegmentation.goals.tip"
        >
          Enter 20-30 goals for your community (max: 60 goals)
        </p>
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px"
          class="u-marginBottom-24"
        >
          <button
            mat-stroked-button
            color="primary"
            (click)="openEditHubSegmentationItemsDrawer(group, segmentation)"
            i18n="@@hubConfigSegmentation.goals.editCta"
          >
            Edit goals
          </button>
          <button
            mat-button
            color="primary"
            (click)="sortCategoriesAlphabetically(group, segmentation)"
            i18n="@@hubConfigSegmentation.sortCta"
          >
            Sort alphabetically
          </button>
        </div>
      </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="32px">
      <div fxFlex="65%">
        <ng-container *ngTemplateOutlet="categoriesList"></ng-container>
      </div>
      <div fxFlex="35%">
        <app-best-practices-card
          [body]="goalsBestPractices.body"
          [title]="goalsBestPractices.title"
        ></app-best-practices-card>
      </div>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="'industries'">
    <div fxLayout="row" fxLayoutAlign="space-between start">
      <div fxFlex="60%">
        <p
          class="u-marginBottom-16 text-subtitle-2"
          i18n="@@hubConfigSegmentation.interests.title"
        >
          Interests
        </p>
        <p
          *ngIf="segmentation.description.length"
          class="color-grey-300 u-marginBottom-16"
        >
          {{ segmentation.description }}
        </p>
        <p
          class="color-grey-300 u-marginBottom-16"
          i18n="@@hubConfigSegmentation.interests.tip"
        >
          Enter 20-30 interests for your community (max: 60 interests).
        </p>
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px"
          class="u-marginBottom-24"
        >
          <button
            mat-stroked-button
            color="primary"
            (click)="openEditHubSegmentationItemsDrawer(group, segmentation)"
            i18n="@@hubConfigSegmentation.interests.editCta"
          >
            Edit interests
          </button>
          <button
            mat-stroked-button
            color="accent"
            (click)="editDescription(group, segmentation.key)"
          >
            <ng-container
              *ngIf="segmentation.description.length"
              i18n="@@hubConfigSegmentation.interests.editDescription"
              >Edit description</ng-container
            >
            <ng-container
              *ngIf="!segmentation.description.length"
              i18n="@@hubConfigSegmentation.interests.addDescription"
              >Add description</ng-container
            >
          </button>
          <button
            mat-button
            color="primary"
            (click)="sortCategoriesAlphabetically(group, segmentation)"
            i18n="@@hubConfigSegmentation.sortCta"
          >
            Sort alphabetically
          </button>
        </div>
      </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="32px">
      <div fxFlex="65%">
        <ng-container *ngTemplateOutlet="categoriesList"></ng-container>
      </div>
      <div fxFlex="35%">
        <app-best-practices-card
          [body]="interestsBestPractices.body"
          [title]="interestsBestPractices.title"
        ></app-best-practices-card>
      </div>
    </div>
  </ng-container>
</div>
<ng-template #categoriesList>
  <div
    class="u-border-grey100 u-showScrollBar u-overflow-hidden u-marginBottom-16"
    [ngStyle]="{ maxHeight: '325px', overflowY: 'scroll' }"
    cdkDropList
    (cdkDropListDropped)="dropItem($event)"
  >
    <div
      *ngFor="let item of segmentation.categories; let lastItem = last"
      class="bg-color-white u-cursor-move bg-color-black--hover-4"
      fxLayout="row"
      fxLayoutAlign="space-between center"
      [ngClass]="{ 'u-borderBottom-grey100': !lastItem }"
      cdkDrag
    >
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px">
        <button mat-icon-button cdkDragHandle [ngStyle]="{ opacity: '0.4' }">
          <mat-icon>drag_indicator</mat-icon>
        </button>
        <p>
          {{ item | translationLookup: ['@@groupIndustry', '@@groupOffering'] }}
        </p>
      </div>
      <button
        mat-icon-button
        (click)="removeCategory(item, segmentation, group)"
      >
        <mat-icon class="md-18 color-grey-300 u-paddingBottom-24"
          >close</mat-icon
        >
      </button>
    </div>
  </div>
</ng-template>
